import { ReviewItemProps } from '@zola/zola-ui/src/components/PreAuthV3/ReviewItem';

export const reviewItems: ReviewItemProps[] = [
  {
    name: 'Blanca',
    reviewText:
      'I loved organizing and switching around my photos! Everything was so fun to play with that I almost didn’t want it to end… I finished up ordering one for us and one for my parents, and they’re just as fun and beautiful to flip through in person.',
    title: 'Seriously addicting',
  },
  {
    name: 'Priya',
    reviewText:
      'Shipping was super fast and the unboxing was just… wow. I never thought I’d get emotional over an album, but I definitely teared up a few times! Our photos come to life on the thick pages and the leather cover is just gorgeous.',
    title: 'Happy tears',
  },
  {
    name: 'Jeff',
    reviewText:
      'The fact Zola did the layout for me was the icing on the cake. I wanted to surprise my wife with the album for our anniversary, but felt really overwhelmed on other sites. On Zola, all I had to do was upload our photos and drag some things around. Turned out great... and she is so impressed!',
    title: 'Like magic',
  },
];
